import React from 'react';

export default function Demo() {
    return (
        <div style={{ display: 'flex' }}>
            {/* Left Sticky Navigation Bar */}
            <div>
                <div>
                    hey merhaba
                </div>
                <div>
                    hey merhaba
                </div>
                <div>
                    hey merhaba
                </div>
                <div>
                    hey merhaba
                </div>
                <div style={{
                    position: 'sticky',
                    top: '0',
                    height: '100vh',
                    backgroundColor: 'lightgray',
                    padding: '10px',
                    width: '200px'
                }}>
                    <h2>Navigation</h2>
                    <ul style={{ listStyleType: 'none', padding: 0 }}>
                        <li><a href="#section1">Section 1</a></li>
                        <li><a href="#section2">Section 2</a></li>
                        <li><a href="#section3">Section 3</a></li>
                        <li><a href="#section4">Section 4</a></li>
                    </ul>
                </div>
            </div>

            {/* Right Content Section */}
            <div style={{ marginLeft: '20px', padding: '10px', flex: 1 }}>
                <h1>Demo</h1>
                <div id="section1" style={{ height: '500px', backgroundColor: 'yellow', padding: '10px' }}>
                    <h2>Section 1</h2>
                    <p>This is section 1 content.</p>
                </div>
                <div id="section2" style={{ height: '500px', backgroundColor: 'lightblue', padding: '10px' }}>
                    <h2>Section 2</h2>
                    <p>This is section 2 content.</p>
                </div>
                <div id="section3" style={{ height: '500px', backgroundColor: 'lightgreen', padding: '10px' }}>
                    <h2>Section 3</h2>
                    <p>This is section 3 content.</p>
                </div>
                <div id="section4" style={{ height: '500px', backgroundColor: 'lightcoral', padding: '10px' }}>
                    <h2>Section 4</h2>
                    <p>This is section 4 content.</p>
                </div>
            </div>
        </div>
    );
}